import './inc/style';
import 'regenerator-runtime/runtime';
import 'core-js/stable';

(() => {

    document.addEventListener('DOMContentLoaded', () => {
        // show cookie consent box on load of page
        showCookieConsentOnLoad();

        // Accept all
        document
            .querySelector('.cookie-consent-accept-all')
            .addEventListener('click', (e) => {

                e.preventDefault();

                showElement('manage-consent-toggle-cookie-consent');

                showElement('manage-consent-toggle-cookie-consent');

                hideElement('cookie-consent');

                hideElement('about-cookies');

                setCookies(true);

                setCookie('cookie-consent-accept-all', true, 1000);

                eraseCookie('cookie-consent-dismiss');

                if (jQuery('#cookie-consent').hasClass('backdrop')) {
                    jQuery('html').css('overflow', 'initial');
                }

                log();

            });

        // View preferences
        document
            .querySelector('.cookie-consent-settings')
            .addEventListener('click', function (e) {
                e.preventDefault();

                hideElement('about-cookies');

                showElement('default', 'block');

                showElement('types', 'block');

                showElement('cookie-consent-save', 'block', true);

                addClass('cookie-consent', 'in-setting');

                removeClass('cookie-consent', 'about-in-view');

                removeClass('cookie-consent-buttons', 'about-open', true);

                showDenyAndSave();

                disableSettings();

                changeTitleAndInfo();
            });

        // Dismiss
        document
            .querySelector('.cookie-consent-dismiss')
            .addEventListener('click', function (e) {
                e.preventDefault();

                hideElement('cookie-consent');

                showElement('manage-consent-toggle-cookie-consent');

                setCookie('cookie-consent-dismiss', true, 1000);

                setCookies(false, true);

                eraseCookie('cookie-consent-accept-all');

                removeClass('cookie-consent', 'about-in-view');

                showElement('default', 'block');

                hideElement('about-cookies');

                removeClass('cookie-consent', 'in-setting');

                removeClass('cookie-consent-buttons', 'about-open', true);

                disableSettings();

                if (jQuery('#cookie-consent').hasClass('backdrop')) {
                    jQuery('html').css('overflow', 'initial');
                }

                log();
            });

        // About
        document
            .querySelector('.cookie-consent-about')
            .addEventListener('click', function (e) {
                e.preventDefault();

                document.querySelector('.cookie-consent-about').scrollTop = 0;

                hideElement('default');

                hideElement('cookie-consent-save', true);

                showElement('about-cookies');

                addClass('cookie-consent', 'about-in-view');

                addClass('cookie-consent-buttons', 'about-open', true);

                removeClass('cookie-consent', 'in-setting');

                hideDenyAndSave();

                changeTitleAndInfo('about');

                disableSettings();
            });

        // Save
        document
            .querySelector('.cookie-consent-save')
            .addEventListener('click', function (e) {
                e.preventDefault();

                setCookies();

                setCookie('cookie-consent-dismiss', true, 1000);

                eraseCookie('cookie-consent-accept-all');

                showElement('manage-consent-toggle-cookie-consent');

                hideElement('cookie-consent');

                hideElement('about-cookies');

                removeClass('cookie-consent', 'in-setting');

                removeClass('cookie-consent-buttons', 'about-open', true);

                disableSettings();

                if (jQuery('#cookie-consent').hasClass('backdrop')) {
                    jQuery('html').css('overflow', 'initial');
                }

                log();
            });

        document.querySelectorAll('.cookie-consent-category').forEach((el) => {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                e.target.parentNode.classList.toggle('open');
            });
        });

        // Open cookie consent 
        document
            .getElementById('manage-consent-toggle-cookie-consent')
            .addEventListener('click', function (e) {

                e.preventDefault();

                showElement('types', 'block');

                showElement('default', 'block');

                showElement('cookie-consent');

                hideElement('manage-consent-toggle-cookie-consent');

                addClass('cookie-consent', 'in-setting');

                removeClass('cookie-consent-buttons', 'about-open', true);

                disableSettings();

                changeTitleAndInfo();

                showDenyAndSave();
            });

        // Toggle open by shortcode
        document
            .querySelector('[data-toggle-cookie-consent]')

            .addEventListener('click', function (e) {

                e.preventDefault()

                document
                .getElementById('manage-consent-toggle-cookie-consent').click()

            });

        const setCookies = (allowAll = false, denyAll = false) => {

            let boxes = getBoxes();

            let allowedCookies = [],
                notAllwedCookies = [];

            if (boxes.ticked.length) {
                allowedCookies = boxes.ticked;
            }

            if (boxes.notTicked.length) {
                notAllwedCookies = boxes.notTicked;
            }

            if (denyAll) {
                notAllwedCookies = boxes.ticked;
            }

            if (allowAll) {
                allowedCookies = boxes.ticked.concat(boxes.notTicked);
            }

            if (allowedCookies.length) {
                createScripts(allowedCookies);
            }

            if ( (notAllwedCookies && !allowAll) || (notAllwedCookies && denyAll) ) {
                removeScripts(notAllwedCookies);
            }
        };

        function hideDenyAndSave() {
            hideElement('cookie-consent-dismiss', true);
        }

        function showDenyAndSave() {
            showElement('cookie-consent-dismiss', 'block', true);
            showElement('cookie-consent-save', 'block', true);
        }

        function disableSettings(diabled = false) {
            if (
                document
                    .getElementById('cookie-consent')
                    .classList.contains('in-setting')
            ) {
                document.querySelector(
                    '.cookie-consent-settings',
                ).disabled = true;
            } else {
                document.querySelector(
                    '.cookie-consent-settings',
                ).disabled = false;
            }
        }

        function addClass(selector, className, selectAsClass = false) {
            if (selectAsClass) {
                document.querySelector('.' + selector).classList.add(className);
            } else {
                document.getElementById(selector).classList.add(className);
            }
        }

        function removeClass(selector, className, selectAsClass = false) {
            if (selectAsClass) {
                document
                    .querySelector('.' + selector)
                    .classList.remove(className);
            } else {
                document.getElementById(selector).classList.remove(className);
            }
        }

        function changeTitleAndInfo(dataAttr) {
            const title = document.querySelector(
                '#cookie-consent #title-cookie-consent',
            );
            const info = document.querySelector(
                '#cookie-consent #cookie-consent-message',
            );

            if (dataAttr === 'about') {
                title.innerHTML = title.dataset.about;
                document.querySelector(
                    '#cookie-consent #about-cookies',
                ).innerHTML = info.dataset.about;
            } else {
                title.innerHTML = title.dataset.setting;
                info.innerHTML = info.dataset.setting;
            }
        }

        function toggleClass(id, className) {
            document.getElementById(id).classList.toggle(className);
        }

        function showCookieConsentOnLoad() {
            if (
                !(
                    getCookie('cookie-consent-accept-all') ||
                    getCookie('cookie-consent-dismiss')
                )
            ) {
                setTimeout(function () {
                    showElement('cookie-consent');
                }, 200);
            } else {
                showElement('manage-consent-toggle-cookie-consent', 'block');
            }
        }

        function hideElement(selector, selectAsClass = false) {
            let el;

            if (selectAsClass) {
                el = document.querySelector('.' + selector);
            } else {
                el = document.getElementById(selector);
            }

            el.style.display = 'none';
        }

        function showElement(selector, type = 'flex', selectAsClass = false) {
            let el;

            if (selectAsClass) {
                el = document.querySelector('.' + selector);
            } else {
                el = document.getElementById(selector);
            }

            el.style.display = type;

            if (
                selector === 'cookie-consent' &&
                jQuery('#cookie-consent').hasClass('backdrop')
            ) {
                jQuery('html').css('overflow', 'hidden');
            }
        }

        function getBoxes() {
            if (
                document.querySelectorAll('.cookie-consent-consent-checkbox')
                    .length
            ) {
                let boxesChecked = [],
                    notChecked = [];

                document
                    .querySelectorAll('.cookie-consent-consent-checkbox')
                    .forEach(function (el) {
                        if (el.checked) {
                            boxesChecked.push(el.dataset.category);
                        } else {
                            notChecked.push(el.dataset.category);
                        }
                    });

                return {
                    ticked: boxesChecked,
                    notTicked: notChecked,
                };
            }

            return {
                ticked: [],
                notTicked: [],
            };
        }

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            var expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        }

        function getCookie(cname) {
            var name = cname + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];

                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }

                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }

            return '';
        }

        function eraseCookie(name) {
            document.cookie = name + '=; Max-Age=-99999999;';
        }

        function createScript(selector, value) {
            jQuery(selector).prepend(value);
        }

        function createScripts(cookiesToSet) {

            jQuery
                .ajax({
                    url: cookie_consent.url,
                    type: 'GET',
                    data: {
                        action: 'load_tracking_scripts',
                    },
                })
                .then((scripts) => {

                    if (scripts && cookiesToSet.length) {

                        const dataLayersEvents = window.dataLayer && window.dataLayer.length ? window.dataLayer.map((e) => e.event) : []

                        cookiesToSet.forEach(function (cookie) {

                            const scriptName = cookie.replace( 'cookie-consent-', '')

                            if ( ! getCookie(cookie) ) {

                                setCookie(cookie, true, 1000);

                                if (!dataLayersEvents.includes(cookie)) {

                                    createScript(
                                        'head',
                                        `<script> window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': '${cookie}' }); </script>`,
                                    );
                                }

                                if( scripts?.head[scriptName] ) {
                                    createScript('head', scripts.head[scriptName]);
                                }

                                if ( scripts?.body[scriptName] ) {
                                    createScript('body', scripts.body[scriptName]);
                                }
                            }

                            document.getElementById(cookie).checked = true;
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        function removeScript(selector, value) {
            let element = jQuery(selector);
            let scriptEL = jQuery(value);
            let matches = [];

            scriptEL.each(function (index, item) {
                element.children().each(function (i, el) {
                    if (
                        jQuery(el).prop('outerHTML') ==
                        jQuery(item).prop('outerHTML')
                    ) {
                        matches.push(jQuery(el));
                        jQuery(el).remove();
                    }
                });
            });
        }

        function removeScripts(cookiesToDelete) {
            jQuery
                .ajax({
                    url: cookie_consent.url,
                    type: 'GET',
                    data: {
                        action: 'load_tracking_scripts',
                    },
                })
                .then((scripts) => {
                    if (scripts && cookiesToDelete.length) {
                        cookiesToDelete.forEach(function (cookie) {
                            // remove scripts
                            const scriptName = cookie.replace( 'cookie-consent-', '' );

                            if( getCookie(cookie) ) {

                                if ( scripts?.head[scriptName] ) {
    
                                    removeScript(
                                        'head',
                                        `<script> window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': '${cookie}' }); </script>`,
                                    );
    
                                    removeScript('head', scripts.head[scriptName]);
    
                                }
    
                                if ( scripts?.body[scriptName] ) {
                                    removeScript('body', scripts.body[scriptName]);
                                }
    
                                document.getElementById(cookie).checked = false;
                                eraseCookie(cookie);

                            }

                        });

                        // update dataLayer if not in array to delete
                        if (window.dataLayer && window.dataLayer.length) {
                            window.dataLayer = window.dataLayer.filter((e) => {
                                if (!cookiesToDelete.includes(e.event)) {
                                    return e;
                                }
                            });
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        function log() {
            const boxes = getBoxes();

            jQuery
                .ajax({
                    url: cookie_consent.url,
                    type: 'POST',
                    data: {
                        action: 'log',
                        boxes: boxes,
                    },
                })
                .then((response) => {
                    // console.log(response);
                })
                .catch((error) => {
                    // console.log(error)
                });
        }

    });
})();
